module.exports = __webpack_public_path__ + "img/violet_060.1ce8279c.png";